// extracted by mini-css-extract-plugin
export default {"drawer":"SideBar_drawer__ziA08","drawerPaper":"SideBar_drawerPaper__ZWwdz","drawerContainer":"SideBar_drawerContainer__m12kq","link":"SideBar_link__HqG-y"};